import constants from "../../config/constants";

const $inject = ['$location', '$scope', '$timeout', '$routeParams', '$http', 'dataService', 'dataSourceService', 'microApiService','settingsService','$q'];

const lbaPagingGridCtrl = function ($location, $scope, $timeout, $routeParams, $http, dataService, dataSourceService, microApiService,settingsService,$q) {
  const vm = this;

  vm.settings.paginationPageSizes = [25, 50, 100];
  vm.settings.paginationPageSize = 100;
  vm.settings.pageNumber = 1;

  vm.dataService = dataService;
  vm.ready = false;
  vm.canAdd = vm.settings.hasOwnProperty('gridAdd');
  vm.addNew = addNew;
  vm.refreshGrid = refreshGrid;
  vm.settingsService = settingsService;
  vm.filteredColumn = vm.settings.defaultFilteredColumn;
  vm.filters = '';
  vm.gridSort = vm.settings.defaultSort;
  
  initializeBackPage();

  vm.isShowingDisabled = false;

  dataSourceService.dataSource = constants.DATA_SOURCES.ODATA;
  dataService.data.activeItem = undefined;
  dataService.data.gotoNext = gotoNext;
  
  // Get Data after delayInMs
  const delayInMs = 500;
  let timeoutPromise;
  $scope.$watch("vm.filters", function() {
    $timeout.cancel(timeoutPromise);  //does nothing, if timeout already done
    timeoutPromise = $timeout(function(){   //Set timeout
      getData(vm.filters);
    }, delayInMs);
  });
  $scope.$watch("vm.filteredColumn", function() {
    $timeout.cancel(timeoutPromise);  //does nothing, if timeout already done
    timeoutPromise = $timeout(function(){   //Set timeout
      getData(vm.filters);
    }, delayInMs);
  });

  var getData = function(searchText = "") {        
    let deferred = $q.defer();
    const url = `${endPointUrl}/api/${vm.settings.endpoint}`;
    const postData = {
      pageSize: vm.settings.paginationPageSize,
      pageNumber: vm.settings.pageNumber - 1,
      searchText: searchText.toLowerCase(),
      searchType: vm.filteredColumn,
      sort: vm.gridSort
    };
    const settings = {};
    vm.searching=true;
    $http.post(url, postData, settings)
    .success((data) => {
      vm.dataService.data.items = data.Results;
      vm.globalData = data.Results;

      $scope.pagingGrid.data = data.Results;
      $scope.pagingGrid.totalItems  = data.TotalCount;

      vm.ready = true;
      vm.searching=false;
      var currentRowIndex = getCurrentIndex();
      dataService.data.hasNext = getNextRow(currentRowIndex+1)!=null;
      dataService.data.hasPrevious = getNextRow(currentRowIndex-1)!=null;
      deferred.resolve(data);
    }).error((data, status) => {
      console.log('Return code: ' + status);
      vm.searching=false;
      deferred.reject(data);
    });
    return deferred.promise;
  };
  var gotoNext = function(next){
    
    var currentRowIndex = getCurrentIndex();
    let nextIndex = currentRowIndex + (next ? 1 : -1);
    var row = getNextRow(nextIndex);
    if(row){
      $scope.gridApi.selection.clearSelectedRows();
      $scope.gridApi.selection.selectRow(row);
      dataService.data.hasNext = getNextRow(nextIndex+1)!=null;
      dataService.data.hasPrevious = getNextRow(nextIndex-1)!=null;
    }
  };
  function getCurrentIndex(){
    var currentRowIndex;
    if(!$scope.gridApi || !$scope.gridApi.selection){
      return -1;
    }
    var selectedRows = $scope.gridApi.selection.getSelectedRows();
    if( selectedRows.length < 1 ){
      // if nothing selected, we'll select the top row
      currentRowIndex = -1;
    } else {
      // if there are multiple selected, we use the first one
      var selectedRow = selectedRows[0];
      var gridRow = $scope.gridApi.grid.getRow(selectedRow);
      currentRowIndex = $scope.gridApi.grid.renderContainers.body.visibleRowCache.indexOf(gridRow);
    }
    return currentRowIndex;
  }
  function getNextRow(nextIndex){
    if($scope.gridApi && 
      $scope.gridApi.grid && 
      $scope.gridApi.grid.renderContainers &&
      $scope.gridApi.grid.renderContainers.body && 
      $scope.gridApi.grid.renderContainers.body.visibleRowCache && $scope.gridApi.grid.renderContainers.body.visibleRowCache[nextIndex]){
      return $scope.gridApi.grid.renderContainers.body.visibleRowCache[nextIndex].entity;
    }
    return null;
  }

  setupGrid();  
  function addCellTitles(){
    if(!vm.settings.gridCols) return;
    vm.settings.gridCols.filter(col=>!col.cellFilter && col.field).forEach(col=>{
      
      col.cellTemplate='<div class="ui-grid-cell-contents" title="{{row.entity.' +  col.field + '}}">{{row.entity.' +  col.field + '}}</div>';
    });
  }
  function setupGrid() {
    addCellTitles();
    $scope.pagingGrid = {
      columnDefs: vm.settings.gridCols,
      paginationPageSizes: vm.settings.paginationPageSizes,
      paginationPageSize: vm.settings.paginationPageSize,
      paginationCurrentPage: vm.settings.pageNumber,
      useExternalPagination: true,
      useExternalSorting: true,
      enableRowSelection: true, 
      enableRowHeaderSelection: false,
      multiSelect: false,
      noUnselect: true,
      onRegisterApi: function(gridApi) {
        $scope.gridApi = gridApi;

        gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
          vm.settings.pageNumber = newPage;
          vm.settings.paginationPageSize = pageSize;
          getData(vm.filters);
        });
         gridApi.core.on.sortChanged($scope, function(grid, sortColumns) {
          vm.gridSort = [];
          if (sortColumns.length>0) {
            vm.gridSort = sortColumns.map((col)=> {return {
                  "column":col.field,
                  "Order": col.sort.direction
                }
            });
          }
          getData(vm.filters);
        });
        gridApi.selection.on.rowSelectionChanged($scope, function(row){  
          let rowIndex = 0;

          // JLF: LOBT-700: undersore's findIndex was removed as it returned false positives
          _.find(vm.dataService.data.items, (item, index) => {
            if (item === row.entity) rowIndex = index;
          });

          if (vm.copyResourceMode) {            
            dataService.get(vm.settings.endpoint, row.entity.id).then((data) => {              
              const duplicate = data;
              duplicate.Name = duplicate.Name + ' COPY';
              delete duplicate.Id;
      
              vm.dataService.post(vm.settings.endpoint, duplicate, true).then(data => {
                data.id = data.Id;
                updatePath(data, rowIndex);
              });
            });
            
            return;
          }

          dataService.backPath = $location.$$path;

          updatePath(row.entity, rowIndex);
        });
      },
    };
   
    getData();
  }
  function refreshGrid(){
    let currentIndex = getCurrentIndex();
    
    getData(vm.filters).then(data=>{
      
      if($scope.gridApi.grid.rows && $scope.gridApi.grid.rows.length>currentIndex){
        var gridRow = $scope.gridApi.grid.rows[currentIndex];
        if(gridRow){
          updatePath(gridRow.entity, currentIndex);
        }
      }
     
      
    });
  }

  function addNew() {
    dataService.backPath = $location.$$path;
   
    if (vm.settings.gridAdd) {
      $location.path($location.$$path + '/add');
    } else {
      dataService.addNewMode = true;
      // Create backup of complete data structure before adding empty item
      dataService.addNewBackup = angular.copy(dataService.data);

      if (vm.resource.rows) {
        vm.resource.rows.push({});
      } else {
        vm.resource.rows = [{}];
      }
      updatePath({}, vm.resource.rows.length - 1);
    }
  }

  function updatePath(data, index) {
    setBackPage();

    if(!vm.settings.gridItem){
      dataService.data.activeItem = data;
      dataService.data.gotoNext = gotoNext;
      return;
    }
    

    let displayNamePathReady = vm.settings.displayName.replace(/\s+/g, '-').toLowerCase();

    const appendToPath = (vm.settings.gridAdd || vm.settings.gridItem) ? data.id : displayNamePathReady + '/' + index;
    $location.path($location.$$path + '/' + appendToPath);
  }

  function initializeBackPage(){
    if (dataService.backGridFilter != null && dataService.backGridFilter[vm.settings.displayName]) {
      vm.filters = dataService.backGridFilter[vm.settings.displayName]
    }
    
    if (dataService.backGridPage != null && dataService.backGridPage[vm.settings.displayName]) {
      vm.settings.pageNumber = dataService.backGridPage[vm.settings.displayName]
    }
    if (dataService.backGridSort != null && dataService.backGridSort[vm.settings.displayName]) {
      vm.gridSort = dataService.backGridSort[vm.settings.displayName]
    }
  
    if (dataService.backGridPageSize != null && dataService.backGridPageSize[vm.settings.displayName]) {
      vm.settings.paginationPageSize = dataService.backGridPageSize[vm.settings.displayName]
    }
  }
  function setBackPage(){
    if(!dataService.backGridFilter) dataService.backGridFilter = [];
    dataService.backGridFilter[vm.settings.displayName] = vm.filters;

    if(!dataService.backGridPage) dataService.backGridPage = [];
    dataService.backGridPage[vm.settings.displayName] = vm.settings.pageNumber;

    if(!dataService.backGridSort) dataService.backGridSort = [];
    dataService.backGridSort[vm.settings.displayName] = vm.gridSort;

    if(!dataService.backGridPageSize) dataService.backGridPageSize = [];
    dataService.backGridPageSize[vm.settings.displayName] = vm.settings.paginationPageSize ;
  }
};

lbaPagingGridCtrl.$inject = $inject;

export default lbaPagingGridCtrl;



// WEBPACK FOOTER //
// ./src/components/lbaPagingGrid/lbaPagingGridCtrl.js